const doc = [({"da":({"js":({"admin":({"products":({"show":({"show_product_with_name":"Vis produkt: %{name}"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;